import {useContext} from "react";
import {StepsContext} from "../context/StepsContext";

export const useSteps = () => {
    return useContext(StepsContext);
}